import { motion } from "motion/react";
import { Check, Clock, Shield } from "lucide-react";

export function LaunchOffer() {
  return (
    <section className="py-20 bg-[#0B0E14] relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Timer Header */}
          <div className="bg-[#FF4D00]/10 border border-[#FF4D00]/30 rounded-t-2xl p-4 flex flex-wrap items-center justify-center gap-4 text-[#FF4D00]">
            <Clock className="w-5 h-5 animate-pulse" />
            <span className="font-mono font-bold">OFERTA ENCERRA EM:</span>
            <div className="flex gap-2 font-mono text-xl font-bold text-white">
              <span className="bg-[#FF4D00] px-2 rounded">00</span>:
              <span className="bg-[#FF4D00] px-2 rounded">14</span>:
              <span className="bg-[#FF4D00] px-2 rounded">35</span>
            </div>
          </div>

          {/* Pricing Card */}
          <div className="bg-[#1A1F2B] border-x border-b border-gray-800 rounded-b-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden">
             {/* Glow */}
             <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-[#00F5FF]/5 rounded-full blur-[80px]" />
             
             <div className="flex flex-col md:flex-row gap-8 items-center justify-between relative z-10">
               <div className="flex-1">
                 <h2 className="text-3xl font-bold text-white mb-2">Plano Vitalício Founder</h2>
                 <p className="text-gray-400 mb-6">Acesso total a todas as ferramentas atuais e futuras.</p>
                 
                 <div className="space-y-3">
                   {['Rastreamento Ilimitado', 'Fingerprinting Avançado', 'Bloqueador de Bots', 'Dashboard em Tempo Real', 'Suporte Prioritário'].map((item) => (
                     <div key={item} className="flex items-center gap-2 text-gray-300">
                       <div className="p-1 rounded bg-[#00F5FF]/10 text-[#00F5FF]">
                         <Check className="w-4 h-4" />
                       </div>
                       {item}
                     </div>
                   ))}
                 </div>
               </div>

               <div className="w-full md:w-auto bg-[#0B0E14] p-6 rounded-xl border border-gray-800 text-center min-w-[300px]">
                 <div className="text-sm text-gray-500 line-through mb-1">De R$ 997/ano</div>
                 <div className="text-4xl font-bold text-white mb-2">
                   R$ 297
                   <span className="text-sm font-normal text-gray-400">/único</span>
                 </div>
                 <p className="text-xs text-[#00F5FF] mb-6">Economia de 70% hoje</p>
                 
                 <button className="w-full bg-[#FF4D00] hover:bg-[#FF6B35] text-white font-bold py-4 rounded-lg transition-colors shadow-[0_0_20px_rgba(255,77,0,0.3)] hover:shadow-[0_0_30px_rgba(255,77,0,0.5)]">
                   COMPRAR AGORA
                 </button>
                 
                 <div className="mt-4 flex items-center justify-center gap-2 text-xs text-gray-500">
                   <Shield className="w-3 h-3" />
                   Garantia de 30 Dias
                 </div>
               </div>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
}
